import { Avatar } from '@mui/material'
import Chip from '@mui/material/Chip'
import Stack from '@mui/material/Stack'
import React from 'react'
import bed_icon from '../../assets/images/icons/bed_icon.svg'
import activity_icon from '../../assets/images/icons/activity_icon.svg'
import destination from '../../assets/images/icons/destination.svg'

export default function ChipTag(props) {
  let tagInfo = props.tagInfo
  return (
    <Stack direction="row" spacing={0.5} sx={{}}>
      <Chip
        avatar={
          <Avatar
            alt={tagInfo.label}
            src={
              tagInfo.item_type === 'HOTEL'
                ? bed_icon
                : tagInfo.item_type === 'ACTIVITY'
                ? activity_icon
                : destination
            }
            style={{ width: '16px', height: '16px', paddingRight: '0px' }}
          />
        }
        label={tagInfo.label}
        style={{ background: tagInfo.bgColor, padding: '0px' }}
        sx={{ height: '22px' }}
      />
    </Stack>
  )
}
